import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";
import { SharedFormService } from "src/app/shared-utility/services/shared-form.service";
import { SharedStateService } from "src/app/shared-utility/services/shared-state.service";
import { ActivatedRoute, ParamMap } from "@angular/router";

@Component({
  selector: "app-auth-reset-form",
  templateUrl: "./auth-reset-form.component.html",
  styleUrls: ["./auth-reset-form.component.scss"],
})
export class AuthResetFormComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  resetUsernameformGroup: FormGroup;
  resetPasswordformGroup: FormGroup;
  securityQuestionsformGroup: FormGroup;
  confirmPasswordformGroup: FormGroup;
  resetSubscription: Subscription;
  blnShowErrorTop: boolean = false;
  blnShoweErrorBottom: boolean = false;
  usernameReset = false;
  passwordReset = false;
  firstName: string;
  lastName: string;
  emailAddress: string;
  usernameResetError: boolean = false;
  usernameResetSuccess: boolean = false;
  confirmPass: boolean = true;
  blnHasCapital: boolean = false;
  blnHasOneNumber: boolean = false;
  blnHasSpecialChar: boolean = false;
  blnHasLength: boolean = false;
  blnLowerCase: boolean = false;
  public Password = "";
  securityQuestionScreen: boolean = false;
  newPasswordResetScreen: boolean = false;
  registerationSuccess = false;
  reset: string;
  Email: string = "";
  resetErrorMsg = `<p>One or more pieces of information entered do not match our records. Please try again or contact us at 1-844-447-5662 for additional assistance.,
  </p> <p>Alternatively,click on the Register button below if you do not have a current account.</p>`
  SecurityAnswers: any[] = [];
  newPasswordShowPasswordIcon: boolean = false;
  confirmPasswordShowPasswordIcon: boolean = false;
  blnPasswordBoxValid: boolean = false;

  constructor(
    private fb: FormBuilder,
    private sharedStateSvc: SharedStateService,
    private formDataSvc: SharedFormService,
    private router: Router,
    private toast: ToastrService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe((p: ParamMap) => {
      this.reset = p.get("id");
    });

    if (!(this.reset == 'reset-username' || this.reset == 'reset-password')) {
      this.router.navigate(["/login"]);
    }

    this.formDataSvc.changeUsername.subscribe((res) => {
      this.usernameReset = res;
    });
    this.formDataSvc.changePassword.subscribe((res) => {
      this.passwordReset = res;
    });
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
    this.resetUsernameformGroup = this.fb.group({
      firstName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^([A-z]+[,.]?[ ]?|[a-z]+['-]?)+$"),
        ]),
      ],
      lastName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^([A-z]+[,.]?[ ]?|[a-z]+['-]?)+$"),
        ]),
      ],
      email: [
        "",
        Validators.compose([Validators.required, Validators.pattern(re)]),
      ],
    });
    this.securityQuestionsformGroup = this.fb.group({
      answer1: ["", Validators.compose([Validators.required])],
      answer2: ["", Validators.compose([Validators.required])],
      answer3: ["", Validators.compose([Validators.required])],
    });
    this.resetPasswordformGroup = this.fb.group({
      userName: ["", Validators.required],
      email: [
        "",
        Validators.compose([Validators.required, Validators.pattern(re)]),
      ],
    });
    this.confirmPasswordformGroup = this.fb.group({
      passcode: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(
            "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]+).{8,12}$"
          ),
        ]),
      ],
      confirmPasscode: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern(
            "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*]+).{8,12}$"
          ),
        ]),
      ],
    });
  }
  ResetUsername(): void {
    if (this.resetUsernameformGroup.valid) {
      const finalPayload = {
        FirstName: this.resetUsernameformGroup.get("firstName").value,
        LastName: this.resetUsernameformGroup.get("lastName").value,
        Email: this.resetUsernameformGroup.get("email").value,
      };
      this.formDataSvc.hideLoader.next(true);
      this.resetSubscription = this.sharedStateSvc
        .usernameReset(finalPayload)
        .subscribe(
          (resp) => {
            if (resp.Status !== "ERROR") {
              this.formDataSvc.hideLoader.next(false);
              this.usernameResetSuccess = true;
              this.usernameResetError = false;
              if (window.screen.width <= 480) {
                this.toastr.success(`Your username has been sent to the email provided.`);
              }
            } else {
              this.formDataSvc.hideLoader.next(false);
              this.usernameResetError = true;
              this.usernameResetSuccess = false;
              if (window.screen.width <= 480) {
              this.toastr.error(this.resetErrorMsg, '', { enableHtml: true });
              }
            }
          },
          (error: any) => {
            this.formDataSvc.hideLoader.next(false);
            this.usernameResetError = true;
            this.usernameResetSuccess = false;
            if (window.screen.width <= 480) {
              if (window.screen.width <= 480) {
              this.toastr.error(this.resetErrorMsg, '', { enableHtml: true });
              }
            }
          }
        );
    }
  }
  redirectConfirmPassScreen() {
    this.confirmPass = true;
    this.securityQuestionScreen = false;
    this.newPasswordResetScreen = false;
  }
  redirectToSecurityQuesScreen() {
    this.confirmPass = false;
    this.securityQuestionScreen = true;
    this.newPasswordResetScreen = false;
  }
  securityQuesList: any;
  ResetPassword(): void {
    this.securityQuesList =
      this.sharedStateSvc.resetPasswordSecurityQuestions();
    if (this.resetPasswordformGroup.valid) {
      const finalPayload = {
        UserName: this.resetPasswordformGroup.get("userName").value,
        EmailAddress: encodeURIComponent(this.resetPasswordformGroup.get("email").value),
      };
      this.formDataSvc.hideLoader.next(true);

      this.resetSubscription = this.sharedStateSvc
        .passwordReset(finalPayload)
        .subscribe(
          (resp) => {
            this.securityQuesList = [];
            for (
              let questions = 0;
              questions < resp.Payload.length;
              questions++
            ) {
              this.securityQuesList.push({
                Id: +resp.Payload[questions].SecurityQuestion.Id,
                Question: resp.Payload[questions].SecurityQuestion.QuestionText,
              });
            }
            this.formDataSvc.hideLoader.next(false);

            this.confirmPass = false;
            this.securityQuestionScreen = true;
          },
          (error: any) => {
            /******************Delete after adding orignal API******************/

            this.toastr.error("User not found.");
            this.formDataSvc.hideLoader.next(false);

            /*******************************************************************/
          }
        );
    }
  }
  backToLogin() {
    this.router.navigate(["/login"]);
  }
  validateSecurityQuestions() {
    if (this.securityQuestionsformGroup.valid) {
      let finalPayload = [];
      let i = 0;
      this.SecurityAnswers = [];
      for (let item in this.securityQuestionsformGroup.value) {
        this.SecurityAnswers.push({
          SecurityQuestion: { Id: this.securityQuesList[i].Id },
          Choice: null,
          Answer: this.securityQuestionsformGroup.value[item],
        });
        i++;
      }

      this.formDataSvc.hideLoader.next(false);
      this.confirmPass = false;
      this.securityQuestionScreen = false;
      this.newPasswordResetScreen = true;
    }
  }

  prevPasswordResults: any = null;
  password: string;
  confirmPassword: string;
  confirmPasswordd() {
    const finalPayload = {
      UserName: this.resetPasswordformGroup.value["userName"],
      Password: this.password,
      PasswordConfirmation: this.confirmPassword,
      SecurityAnswers: this.SecurityAnswers,
    };

    this.formDataSvc.hideLoader.next(true);

    this.resetSubscription = this.sharedStateSvc
      .passwordConfirm(finalPayload)
      .subscribe(
        (resp) => {
          if (resp.Status === 'ERROR') {
            if(resp.Errors[0].Message.indexOf("New password matches a previous password") != -1)
            this.toastr.error("You used this password recently. Please choose a different one");
            else if(resp.Errors[0].Message.indexOf("New password matches current account password") != -1)
            this.toastr.error("New password matches current account password");
            else
            this.toastr.error("Security Answers did not match");
            this.formDataSvc.hideLoader.next(false);
          }
          else {
            this.passwordReset = false;
            this.securityQuestionScreen = false;
            this.newPasswordResetScreen = false;
            this.registerationSuccess = true;
          }
          this.formDataSvc.hideLoader.next(false);
        },
        (error: any) => {
          /********************** Delete after adding orignal API **************************/
          this.toastr.error(
            "Your Answers for security Question responses are not correct"
          );
          /*******************************************************************/
          this.formDataSvc.hideLoader.next(false);
        }
      );
  }
  confirmPasswords(isFirstPassword): Function {
    return (checkValue) => {
      if (this.prevPasswordResults && !isFirstPassword) {
        this.prevPasswordResults = {
          ...this.prevPasswordResults,
          firstPasswordField: isFirstPassword,
          verbiage: "Passwords do not match",
          hasPasswordMatch:
            checkValue === this.prevPasswordResults.currentValue,
        };
      }
      return this.prevPasswordResults;
    };
  }
  passKey: boolean = false;
  onKeyUpEvent(event) {
    this.passKey = true;
  }
  checkpassword(event) {
    const specialCharCheck = /[ `!@#$%^&*]/;
    const capitalCheck = /[A-Z]+/;
    const lengthCheck = event && event.length > 7 && event.length < 31;
    const oneNumber = /.*[0-9].*/;
    const lowerCaseCheck = /[a-z]+/;

    this.blnHasCapital = capitalCheck.test(event);
    this.blnHasLength = lengthCheck;
    this.blnHasOneNumber = oneNumber.test(event);
    this.blnHasSpecialChar = specialCharCheck.test(event);
    this.blnLowerCase = lowerCaseCheck.test(event);

    this.blnPasswordBoxValid = (this.blnHasCapital && this.blnLowerCase && this.blnHasOneNumber && this.blnHasSpecialChar && this.blnHasLength);
  }
  passwordValidation(isFirstPassword, value): Function {
    return (checkValue) => {
      const specialCharCheck = /[ `!@#$%^&*]/;
      const capitalCheck = /[A-Z]+/;
      const lengthCheck = checkValue.length > 7 && checkValue.length < 31;
      const oneNumber = /.*[0-9].*/;
      const lowerCaseCheck = /[a-z]+/;
      return {
        hasSpecial: specialCharCheck.test(checkValue),
        hasCapital: capitalCheck.test(checkValue),
        hasLength: lengthCheck,
        hasOneNumber: oneNumber.test(checkValue),
        hasPasswordMatch: false,
        hasLowerCase: lowerCaseCheck.test(checkValue),
        currentValue: checkValue,
        firstPasswordField: isFirstPassword,
        verbiage: " Does not meet requirements",
      };
    };
  }
  submitReset(): void {
    if (this.formGroup.valid) {
      const finalPayload = {
        FirstName: this.formGroup.get("firstName").value,
        LastName: this.formGroup.get("lastName").value,
        NPI: null,
        FacilityNpi: this.formGroup.get("npi").value,
        Username: this.formGroup.get("username").value,
        PrimaryOfficeZipcode: this.formGroup.get("officeZip").value,
      };
      this.formDataSvc.hideLoader.next(true);

      this.resetSubscription = this.sharedStateSvc
        .passwordReset(finalPayload)
        .subscribe(
          (resp) => {
            this.formDataSvc.hideLoader.next(false);
            this.router.navigate(["password-reset-confirmation"]);
          },
          (error: any) => {
            this.formDataSvc.hideLoader.next(false);
            this.toast.error("Please check your filled details");
            this.blnShowErrorTop = true;
            this.blnShoweErrorBottom = true;
          }
        );
    } else {
      Object.keys(this.formGroup.controls).forEach((key) => {
        if (!this.formGroup.controls[key].valid) {
          this.formDataSvc.formStatusEvent.next(key);
        }
      });
      this.blnShowErrorTop = true;
      this.blnShoweErrorBottom = true;
    }
  }
  ngOnDestroy(): void {
    if (this.resetSubscription) {
      this.resetSubscription.unsubscribe();
    }
  }

  redirectLogin(): void {
    this.router.navigate(["/login"]);
  }
  redirectRegister(): void {
    this.router.navigate(["/registration"]);
  }
  toggleNewPassword(){
    this.newPasswordShowPasswordIcon = !this.newPasswordShowPasswordIcon;
  }
  toggleConfirmPassword(){
    this.confirmPasswordShowPasswordIcon = !this.confirmPasswordShowPasswordIcon;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }
}
